import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';
import { unwrappedNavigationTeamIdAtom } from '@/atoms/navigation';
import { DEFAULT_LOCALE_CODE } from '@/consts/i18n';
import { TEAM_BASE_ROUTE } from '@/utils/classicLinks';

export const useTeamNavigationClassic = () => {
  const { iqId } = useAtomValue(unwrappedNavigationTeamIdAtom);
  return `${TEAM_BASE_ROUTE}/${iqId}/`;
};

export const useTeamNavigationNew = () => {
  // Locale comes from the URL segment (already resolved from the setting by
  // RedirectToLocalised), not react-i18next's i18n.language — which lags and made
  // the redirect bounce /de → /en. Reading the URL keeps this non-suspending, as
  // the side nav requires (it renders outside AppShell's Suspense boundary).
  const { locale = DEFAULT_LOCALE_CODE } = useParams();
  const { datahubId } = useAtomValue(unwrappedNavigationTeamIdAtom);

  return `/${locale}/team/${datahubId}/`;
};
